import {IOrganization} from "./organization.model";

export interface IFieldActivity {
    id?: number;
    itemName?: string;
    status?: string;
    description?: string;
  organization?: IOrganization;

}

export class FieldActivity implements IFieldActivity {
    constructor(public id?: number, public itemName?: string, public status?: string, public description?: string
      ,  public organization?: IOrganization
    ) {}
}
